import * as viemChains from 'viem/chains';
import { extractChain, createWalletClient, http, createPublicClient, } from 'viem';
export const getEip1193ProviderForTurnkey = async (account, chainId) => {
    const provider = new CustomEip1193Provider({
        chainId: parseInt(chainId, 16),
        signTypedData: account.signTypedData.bind(account),
        signMessage: account.signMessage.bind(account),
        signTransaction: account.signTransaction.bind(account),
        account,
        address: account.address,
    });
    return provider;
};
class CustomEip1193Provider {
    chainId;
    signTypedData;
    signMessage;
    signTransaction;
    account;
    address;
    constructor(args) {
        this.chainId = args.chainId ?? 1;
        this.signTypedData = args.signTypedData;
        this.signMessage = args.signMessage;
        this.account = args.account;
        this.address = args.address;
        this.signTransaction = args.signTransaction;
    }
    async requestAccounts() {
        return [this.address];
    }
    getClient() {
        return createWalletClient({
            chain: this.getChain(),
            transport: http(),
        });
    }
    getChain() {
        const chain = extractChain({
            id: this.chainId,
            chains: Object.values(viemChains),
        });
        return chain;
    }
    on(_event, _listener) {
        throw new Error('Not implemented');
    }
    removeListener(..._args) {
        throw new Error('Not implemented!');
    }
    async request(args) {
        if (args.method === 'eth_requestAccounts') {
            return this.requestAccounts();
        }
        if (args.method === 'eth_signTypedData') {
            if (!args.params) {
                throw new Error('params is required');
            }
            return this.signTypedData(args.params[0]);
        }
        if (args.method === 'eth_signMessage') {
            if (!args.params) {
                throw new Error('params is required');
            }
            return this.signMessage(args.params[0]);
        }
        if (args.method === 'eth_chainId') {
            return this.chainId;
        }
        if (args.method === 'wallet_switchEthereumChain') {
            if (!args.params) {
                throw new Error('params is required');
            }
            const chainId = String(args.params[0].chainId).replace('0x', '');
            this.chainId = parseInt(chainId, 16);
            return true;
        }
        if (args.method === 'eth_sendTransaction') {
            if (!args.params) {
                throw new Error('params is required');
            }
            const accountClient = createWalletClient({
                account: this.account,
                chain: this.getChain(),
                transport: http(),
            });
            const client = this.getClient();
            const parseHexValue = (value) => {
                if (typeof value === 'string') {
                    const hexValue = value.startsWith('0x') ? value : `0x${value}`;
                    return BigInt(hexValue);
                }
                return BigInt(value);
            };
            const txData = args.params[0];
            const processedTransaction = { ...txData };
            const hexFields = [
                'value',
                'gas',
                'gasLimit',
                'gasPrice',
                'maxFeePerGas',
                'maxPriorityFeePerGas',
            ];
            for (const field of hexFields) {
                if (processedTransaction[field] !== undefined) {
                    processedTransaction[field] = parseHexValue(processedTransaction[field]);
                }
            }
            const preparedTransaction = await accountClient.prepareTransactionRequest(processedTransaction);
            const signedTransaction = await this.signTransaction(preparedTransaction);
            const tx = await client.sendRawTransaction({
                serializedTransaction: signedTransaction,
            });
            return tx;
        }
        if (args.method === 'eth_getTransactionCount') {
            if (!args.params) {
                throw new Error('params is required');
            }
            const client = createPublicClient({
                chain: this.getChain(),
                transport: http(),
            });
            const count = await client.getTransactionCount({
                address: this.address,
                blockTag: 'pending',
            });
            return `0x${count.toString(16)}`;
        }
        return this.getClient().request({
            method: args.method,
            params: args.params,
        });
    }
}
